

<template>
    <div class="flex items-start space-x-4 text-base sm:text-sm">
        <div class="flex-none mt-1">
            <a :href="`/${song.urlSlug}`"
                   :alt="song.showTitle"
                   :title="song.showTitle" class="guide-img-container">
                <img class="object-cover w-8 rounded-lg shadow-lg"
                    :src="song.showLogo"
                :alt="`${song.showTitle} logo`" :title="`${song.showTitle} logo`">
            </a>
        </div>

        <div class="flex-grow">
            <a :href="`/${song.urlSlug}`"
                   :alt="song.showTitle"
                   :title="song.showTitle"
               class="block font-medium hover:underline">
                <h3 class="">{{ song.title }}</h3>
            </a>
            <p><em class="text-sm text-gray-900 "> 
                    <span class="space-x-1 tag-list">
                        <a v-for="character in song.characters"
                            :key="character.id"
                            :alt="character.name"
                            :title="character.name"
                            class="text-sm text-gray-900"
                            :href="`/${character.id}`">{{ character.name }}</a>
                    </span>
                </em></p>
        </div>
    </div>
</template>



<script lang="ts" setup>
import {defineProps} from "vue";
import {AuditionSongDto} from "@/dtos";

const props = defineProps<{
    song: AuditionSongDto,
}>();

const song: AuditionSongDto = props.song;

</script>
<style>

</style>